export const parseFragment = (): {[key:string]: string} => {
    const fragment = window.location.hash;
    
    if (!fragment || !fragment.length || fragment.length < 2) {
        return null;
    }
    
    const splitFragment: string[] = window.location.hash.slice(1).split('&');

    if (!splitFragment || !splitFragment.length) {
        return null;
    }

    const objFragment: {[key:string]: string} = splitFragment.reduce((objFragment, item) => {
        const [key, val] = item.split('=');
        objFragment[key] = val;
        return objFragment;
    }, {});

    return objFragment;
}